import {
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {
  DashboardFacade,
  ProjectsFacade,
  SharedFacade,
  customEncode,
  isFeatureEnabled,
} from '@piqet-angular/data';
import { ColDef } from 'ag-grid-community';
import { ActionButtonComponent } from 'libs/ui/src/lib/action-button/action-button.component';
import { ProjectsDataGridService } from '../projects/projects-data-grid.service';
import { ActivatedRoute, Router } from '@angular/router';
import { GridMyProjectImageComponent } from 'libs/ui/src/lib/grid-my-project-image/grid-my-project-image.component';
import { GridProjectLinkComponent } from 'libs/ui/src/lib/grid-project-link/grid-project-link.component';
import {
  AccessPermissionService,
  CustomModalService,
  FeatureCodes,
  mainModuleName,
  rolesModuleName,
} from '@piqet-angular/shared';
import { ProjectsService } from 'libs/data/src/lib/services/projects/projects.service';
import { ToastrService } from 'ngx-toastr';
import { catchError, of, finalize, Subscription, Observable } from 'rxjs';
import { SharedService } from 'libs/data/src/lib/services/shared/shared.service';
import { guideTourStep2Str } from '@piqet-angular/shared';
import { InlineTooltipComponent } from 'libs/ui/src/lib/inline-tooltip/inline-tooltip.component';
import { CookieService } from 'ngx-cookie-service';
import { JoyrideService } from 'ngx-joyride';
@Component({
  selector: 'piqet-angular-projects',
  templateUrl: './projects.component.html',
  styleUrls: ['./projects.component.scss'],
})
export class ProjectsComponent implements OnInit, OnDestroy {
  @Input() projectList: any;
  @Input() class: any;
  @Input() eleId: any;
  guideTourStep2Str = guideTourStep2Str;
  columnDefs: ColDef[];
  gridName = 'Dashboard Project';
  gridNameProductProject = 'Product project';
  countryList: any;
  isProjectTab = false;
  activatedRoute: any;
  sortColumnState: any;
  productProjectPayload: any;
  headerDataForPackagingProject = {
    materialName: 'Packaging projects',
  };
  headerDataForProductProject = {
    materialName: 'Product projects',
  };
  flagName: any;
  frameworkComponents = {
    actionRenderer: ActionButtonComponent,
    GridMyProjectImageComponent: GridMyProjectImageComponent,
    GridProjectLinkComponent: GridProjectLinkComponent,
    inlineTooltipComponent: InlineTooltipComponent,
  };
  createAccess = false;
  showViewAllData = false;
  showCreateAllData = false;
  deleteProductProjectData: Subscription;
  hideUnhideSubjectDashboard!: Subscription;
  scrollTrigger!: Subscription;
  accessRoleJson: any = [];
  userRole: string = '';
  isCheckProductAccessDisabled: boolean = false;
  FeatureCodes = FeatureCodes;
  constructor(
    private projectsDataGridService: ProjectsDataGridService,
    public sharedFacade: SharedFacade,
    public route: ActivatedRoute,
    private toaster: ToastrService,
    private dashboardFacade: DashboardFacade,
    public projectFacde: ProjectsFacade,
    public router: Router,
    private modal: CustomModalService,
    public joyrideService: JoyrideService,
    private projectService: ProjectsService,
    private cookieService: CookieService,
    private sharedService: SharedService,
    private accessService: AccessPermissionService,
    private elementRef: ElementRef
  ) {
    this.activatedRoute = this.route.snapshot.routeConfig?.path;
    if (window.location.href.includes('projects')) {
      this.isProjectTab = true;
    }
    const userRole = this.cookieService.get('u_type');
    this.userRole = this.sharedService.decodeURIComponentParam(userRole)?.toLowerCase();
    this.columnDefs = this.isProjectTab
      ? this.projectsDataGridService.getProjectsTabDataColumn(this.activatedRoute)
      : this.projectsDataGridService.getDashboardProjectsDataColumn(
          this.activatedRoute,
          this.userRole
        );
    this.createAccess = this.projectsDataGridService.isAccess(this.activatedRoute)
      ? this.projectsDataGridService.isAccess(this.activatedRoute)?.isCreate
      : true;
    this.deleteProductProjectData =
      this.projectsDataGridService.deleteProductProjectDashboard$.subscribe((deleteData: any) => {
        this.deleteProductProject(deleteData[0]);
      });
  }

  isProjectOverViewAccess = (type: 'view' | 'edit' | 'create' | 'delete' | 'overview') => {
    return (
      this.accessService.hasModulePermission(
        rolesModuleName.packageScenario,
        mainModuleName.projectsModule,
        type
      ) ||
      this.accessService.hasModulePermission(
        rolesModuleName.productScenario,
        mainModuleName.projectsModule,
        type
      )
    );
  };

  ngOnInit(): void {
    this.showViewAllData = this.isProjectOverViewAccess('overview');
    this.showCreateAllData = this.isProjectOverViewAccess('create');
    this.isCheckProductAccessDisabled = !isFeatureEnabled(FeatureCodes.PRODUCT_PROJECT);
    const accessRole: any =
      localStorage.getItem('access') || localStorage.getItem('access') !== 'undefined'
        ? localStorage.getItem('access')
        : undefined;
    this.accessRoleJson = accessRole ? JSON.parse(accessRole) : [];
    this.sharedFacade.getCountryList();
    this.sharedFacade.countryList$.subscribe(data => {
      this.countryList = data;
    });
    this.hideUnhideSubjectDashboard =
      this.projectsDataGridService.hideUnhideSubjectDashboard$.subscribe((data: any) => {
        this.hideUnhideDashboard(data);
      });
  }

  hasPackagingAccess(): boolean {
    if (!this.accessRoleJson.length) {
      return true;
    } else {
      return this.accessRoleJson.some(
        (data: any) => data.moduleName?.toLowerCase() === 'packaging' && data.isOverview
      );
    }
  }

  hasProductAccess(): boolean {
    if (!this.accessRoleJson.length) {
      return true;
    } else {
      return this.accessRoleJson.some(
        (data: any) => data.moduleName?.toLowerCase() === 'product' && data.isOverview
      );
    }
  }

  hideUnhideDashboard(data: any) {
    if (data?.projectType == 'Product project') {
      this.updateVisibility(
        () => this.projectService.UpdateProductVisibility(data.projectId, false),
        res => this.dashboardFacade.GetDashboardData()
      );
    } else {
      this.updateVisibility(
        () => this.projectService.UpdateProjectVisibility(data.projectId, false),
        res => this.dashboardFacade.GetDashboardData()
      );
    }
  }

  private updateVisibility(updateFn: () => Observable<any>, onSuccess: (res: any) => void) {
    updateFn()
      .pipe(
        catchError((error: any) => {
          this.toaster.error('An error occurred. Please try again later.');
          return of(null);
        })
      )
      .subscribe(res => {
        if (res) {
          if (res.messageType) {
            this.toaster.error(res.message);
          } else {
            this.toaster.success(res.message);
            onSuccess(res);
          }
        }
      });
  }

  scrollToTop(): void {
    setTimeout(() => {
      const parentElement = this.elementRef.nativeElement.querySelector('#targetDiv');
      if (parentElement) {
        const y = parentElement.getBoundingClientRect().top + window.pageYOffset - 215;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    }, 100);
  }

  goToEnvSaving() {
    this.scrollToTop();
  }

  ngAfterViewInit() {
    this.route.queryParams.subscribe((res: any) => {
      if (res.isFromProj) this.scrollToTop();
    });
  }

  deleteProductProject(data: any) {
    this.projectService
      .deleteProductProject(data.projectId)
      .pipe(
        catchError((error: any) =>
          of(this.toaster.error('An error occurred. Please try again later.'))
        ),
        finalize(() => {
          this.dashboardFacade.GetDashboardData();
        })
      )
      .subscribe(res => {
        res.messageType ? this.toaster.error(res.message) : this.toaster.success(res.message);
      });
  }

  async selectAddNewProject() {
    this.modal.invoke('selectAddProject', {
      initialState: {
        lableName: 'Add Packaging and Product projects',
      },
      class: 'pallet-view-modal',
    });
    this.modal.ref.content.addNewProject.subscribe((savePallet: any) => {
      this.addNewProject(savePallet);
    });
  }

  async addNewProject(type: string) {
    if (type == 'package') {
      const label = 'Add new project';
      let response = await this.projectService.getMyAllProjectModalData(0);
      this.modal.invoke('newMyProjects', {
        initialState: {
          newMyProjects: response.data,
          pathName: '',
          label: label,
          processColDef: this.projectsDataGridService.getNewDefaultSettingColumn(),
        },
        class: 'modal-xl',
      });
      this.modal.ref?.content.saveNewMyProjectEvent.subscribe((saveNewMyProjectEvent: any) => {
        this.addUpdatePackagingProject(saveNewMyProjectEvent);
      });
    } else if (type == 'product') {
      const labelProduct = 'Make a product';
      let response = await this.projectService.getMyAllProductProjectModalEditData(0, false, 0);
      this.modal.invoke('newMyProductProjects', {
        initialState: {
          newMyProductProjects: response.data,
          pathName: this.activatedRoute,
          label: labelProduct,
        },
        class: 'modal-xl',
      });
      this.modal.ref?.content.saveNewMyProductProjectEvent.subscribe(
        (saveNewMyProductProjectEvent: any) => {
          this.addProductProject(saveNewMyProductProjectEvent);
        }
      );
    }
  }

  addProductProject(data: any) {
    this.projectService
      .saveProjectProduct(data)
      .pipe(
        catchError((error: any) =>
          of(this.toaster.error('An error occurred. Please try again later.'))
        ),
        finalize(() => {
          this.getProductProjects();
        })
      )
      .subscribe(res => {
        res.messageType ? this.toaster.error(res.message) : this.toaster.success(res.message);
        if (
          this.projectsDataGridService.isAccess(this.activatedRoute).isView ||
          this.projectsDataGridService.isAccess(this.activatedRoute).isEdit
        ) {
          localStorage.setItem('productConfigId', res.data);
          this.router.navigate([
            'projects/product-configuration',
            customEncode(btoa(res.data)),
            'setting',
          ]);
        }
      });
  }

  getProductProjects() {
    this.projectService.getMyAllProductProjectList().subscribe();
  }

  getPackagingProjects() {
    this.projectService.getMyAllProjectList().subscribe();
  }

  addUpdatePackagingProject(data: any) {
    this.projectService
      .addEditMyAllProjectData(data)
      .pipe(
        catchError((error: any) =>
          of(this.toaster.error('An error occurred. Please try again later.'))
        ),
        finalize(() => {
          this.modal.close();
          this.getPackagingProjects();
        })
      )
      .subscribe(res => {
        res.messageType ? this.toaster.error(res.message) : this.toaster.success(res.message);
        if (
          this.projectsDataGridService.isAccess(this.activatedRoute, 'packaging').isView ||
          this.projectsDataGridService.isAccess(this.activatedRoute, 'packaging').isEdit
        ) {
          const encodedValue = encodeURIComponent(res.data);
          this.router.navigate([
            'projects/projects-setting',
            customEncode(btoa(encodedValue)),
            'setting',
          ]);
        }
      });
  }

  startTour() {}

  ngOnDestroy() {
    this.deleteProductProjectData.unsubscribe();
    this.hideUnhideSubjectDashboard.unsubscribe();
  }
}
